import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { ItemRow } from '@models/item';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    item: ItemRow;
}

function ItemText({ item }:Props) {
    const {
        salePrice, name, nameEn, nameJa,
    } = item;
    const itemName = useGlobalName({ name, nameEn, nameJa });
    const { t } = useTranslation('items');
    const priceUnit = usePriceUnit();
    return (
        <Fragment>
            <NameText as='div' size='s' align='center'>
                {itemName}
            </NameText>
            <Text size='lg' fontWeight='bold'>
                {salePrice.toLocaleString()}{priceUnit}
            </Text>
        </Fragment>
    );
}

const NameText = styled(Text)`
    font-size: 12px;
    line-height: 20px;
    margin-top: 4px;
    margin-bottom: 2px;
    white-space: wrap;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100%  - 52px);
`;

export default ItemText;
